export default {
  usersChats: [],
  patientsChats: [],
  mimirmanChat: null,
  contacts: [],
  activeChatInfo: null,
  newMessage: null,
  activeMessenger: null,
}
